import React, { useState } from 'react';

export default function AdminOutpostSection({ appId }) {
  const [expandedSections, setExpandedSections] = useState({
    hookdeck: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>🪝</span>
          <span>Webhooks</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Webhook delivery via Outpost (Hookdeck)
        </p>
      </div>

      <div className="space-y-4">
        <div className="border border-gray-200 rounded-lg">
          <button
            onClick={() => toggleSection('hookdeck')}
            className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
          >
            <h4 className="text-sm font-semibold text-gray-900">Outpost (Hookdeck)</h4>
            <span className="text-gray-500 text-sm">
              {expandedSections.hookdeck ? '▼' : '▶'}
            </span>
          </button>
          {expandedSections.hookdeck && (
            <div className="p-4 pt-4 border-t border-gray-200 bg-gray-50">
              <div className="space-y-4 text-sm text-gray-700">
                <p className="text-xs text-gray-600">
                  Hookdeck Outpost handles webhook delivery with automatic retries, event logging, and a per-tenant portal where end users can manage their own webhook endpoints.
                </p>

                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                  <h5 className="font-semibold text-amber-900 mb-1.5">Remember to</h5>
                  <ul className="text-xs text-amber-800 list-disc list-inside space-y-1">
                    <li><a href="https://dashboard.hookdeck.com/settings/project/user-portal" target="_blank" rel="noopener noreferrer" className="text-amber-900 underline hover:text-amber-700">Enable the portal</a> in your Hookdeck project</li>
                    <li>Add a custom domain — usually the <code className="bg-amber-200/60 px-1 rounded">webhooks</code> subdomain prefixed to your app domain (e.g. <code className="bg-amber-200/60 px-1 rounded">webhooks.your-app.com</code>)</li>
                  </ul>
                </div>

                <div>
                  <h5 className="font-semibold text-gray-900 mb-2">Environment Variables</h5>
                  <div className="space-y-1">
                    <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">OUTPOST_API_KEY</p>
                    <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">OUTPOST_API_URL</p>
                  </div>
                </div>

                <div>
                  <h5 className="font-semibold text-gray-900 mb-2">npm Package</h5>
                  <div className="space-y-1">
                    <p className="text-xs font-mono bg-gray-200 px-2 py-1 rounded">@hookdeck/outpost-sdk</p>
                  </div>
                </div>

                <div>
                  <a
                    href="https://dashboard.hookdeck.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-zapt-purple rounded-lg hover:bg-zapt-purple/90 transition-colors"
                  >
                    Open Hookdeck Dashboard →
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
